import { ErrorCard, Errors, componentRegistry as UiComponentRegistry } from '@commerce-webcomponents/ui';
import { useNextgenRouter } from '@nextgen-web-framework/all';
import { componentRegistry, transformComponent } from '../../cms';
import { ComponentType } from '../../cms/registries/types/propTypes';
import type { CmsComponentProps } from './types/propTypes';

const CmsComponent = ({ componentKey, data, ...componentRestProps }: CmsComponentProps) => {
  const router = useNextgenRouter();
  const componentProps = transformComponent(data, componentKey);
  const { componentType, ...rest } = componentProps;
  if (componentType == ComponentType.error_page) {
    return <ErrorCard type={Errors.NotFound} onActionClick={() => router.push('/')} />;
  }
  let ResolvedComponent: React.ElementType = () => <></>;
  if (Object.hasOwn(componentRegistry, componentType)) {
    ResolvedComponent = componentRegistry[componentType];
  } else if (Object.hasOwn(UiComponentRegistry, componentType)) {
    ResolvedComponent = UiComponentRegistry[componentType];
  }
  return (
    <>
      <ResolvedComponent {...rest} {...componentRestProps} />
    </>
  );
};

export default CmsComponent;
